import { request } from "@data/datoRequest"

const requestStaticProps = async (query, variables = {}) => {
  let data = {} as any

  try {
    data = await request({
      query,
      variables,
    })

    return { data }
  } catch (error) {
    return { data: {}, error }
  }
}

export default requestStaticProps
